'use client';

import { categoryType, productCardType } from '@/commonTypes';
import React, { useState } from 'react';
import styles from './styles.module.css';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { Breadcrumb } from '@/components/general/BreadCrumb';
import SingleproductHero from './SingleProductHero';
import { Features } from '../../home/HomeContent/Features/Features';
import ProductCard from '../ProductsContent/ProductCard';
import ProductDetailsSection from './ProductDetailsSection';

interface propsType {
  data?: categoryType;
  content?: string;
  similarItems?: categoryType[];
}
export default function SingleProductContent({ data, content, similarItems = [] }: propsType) {
  const sample = {
    id: 1,
    title: 'لنت ترمز جلو برمبو اصلی — مخصوص پژو ۲۰۶ و ۲۰۷',
    slug: 'product1',

    category: {
      name: 'راهنما',
      slug: 'guide',
    },

    description:
      'لنت ترمز جلو برمبو با فرمولاسیون سرامیکی-فلزی، فاصلهٔ ترمزگیری را در سرعت بالا به‌طور محسوس کاهش می‌دهد و صدای ناخواسته و لرزش پدال را به حداقل می‌رساند. این محصول مطابق استاندارد ECE R90 تولید شده و کاملاً با سیستم ترمز پژو ۲۰۶ و ۲۰۷ سازگار است. پوشش ضدخوردگی روی صفحهٔ فلزی، عمر قطعه را در شرایط آب‌وهوایی مرطوب افزایش می‌دهد. عملکرد پایدار در دمای بالا آن را برای رانندگی شهری پرترافیک و مسیرهای کوهستانی مناسب می‌کند.',

    createdAt: new Date(),

    brand: { brand: 'برمبو', id: 1, slug: 'brb' },
    sku: 'BRK-206-F',

    rate: 4.8,
    rateNumber: 214,
    soldCount: 480,

    shop: {
      id: 1,
      title: 'یدک‌سنتر پاسداران',
      slug: 'shop-1',
      rate: 4.8,
      distance: '۱٫۲ کیلومتر',
      featured: true,
    },

    // attributes: [
    //   {
    //     id: 1,
    //     title: 'جنس',
    //     slug: 'material',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 1,
    //         value: 'سرامیکی-فلزی',
    //       },
    //     ],
    //   },
    //   {
    //     id: 2,
    //     title: 'استاندارد',
    //     slug: 'standard',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 2,
    //         value: 'ECE R90',
    //       },
    //     ],
    //   },
    //   {
    //     id: 3,
    //     title: 'محل نصب',
    //     slug: 'position',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 3,
    //         value: 'محور جلو',
    //       },
    //     ],
    //   },
    //   {
    //     id: 4,
    //     title: 'گارانتی',
    //     slug: 'warranty',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 4,
    //         value: '۱۸ ماه',
    //       },
    //     ],
    //   },
    //   {
    //     id: 5,
    //     title: 'برند',
    //     slug: 'brand',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 5,
    //         value: 'برمبو',
    //       },
    //     ],
    //   },
    //   {
    //     id: 6,
    //     title: 'کشور سازنده',
    //     slug: 'country',
    //     type: 'text',
    //     options: [
    //       {
    //         id: 6,
    //         value: 'ایتالیا',
    //       },
    //     ],
    //   },
    //   // {
    //   //   id: 7,
    //   //   title: 'خودروهای سازگار',
    //   //   slug: 'compatible-cars',
    //   //   type: 'multi',
    //   //   options: [
    //   //     { id: 1, value: 'پژو ۲۰۶' },
    //   //     { id: 2, value: 'پژو ۲۰۷' },
    //   //     { id: 3, value: 'پژو پارس' },
    //   //     { id: 4, value: 'پژو ۴۰۵' },
    //   //   ],
    //   // },
    // ],
    attributes: [
      {
        attributeId: 1,
        attributeName: 'برند',
        attributeSlug: 'brand',
        value: 'برمبو',
      },
      {
        attributeId: 2,
        attributeName: 'جنس',
        attributeSlug: 'material',
        value: 'سرامیکی',
      },
      {
        attributeId: 2,
        attributeName: 'جنس',
        attributeSlug: 'material',
        value: 'فلزی',
      },
      {
        attributeId: 3,
        attributeName: 'استاندارد',
        attributeSlug: 'standard',
        value: 'ECE R90',
      },
      {
        attributeId: 4,
        attributeName: 'محل نصب',
        attributeSlug: 'position',
        value: 'محور جلو',
      },
      {
        attributeId: 5,
        attributeName: 'گارانتی',
        attributeSlug: 'warranty',
        value: '۱۸ ماه',
      },
      {
        attributeId: 6,
        attributeName: 'کشور سازنده',
        attributeSlug: 'country',
        value: 'ایتالیا',
      },
      // {
      //   attributeId: 7,
      //   attributeName: 'خودروهای سازگار',
      //   attributeSlug: 'compatible-cars',
      //   value: 'پژو ۲۰۶',
      // },
      // {
      //   attributeId: 7,
      //   attributeName: 'خودروهای سازگار',
      //   attributeSlug: 'compatible-cars',
      //   value: 'پژو ۲۰۷',
      // },
      // {
      //   attributeId: 7,
      //   attributeName: 'خودروهای سازگار',
      //   attributeSlug: 'compatible-cars',
      //   value: 'پژو پارس',
      // },
      // {
      //   attributeId: 7,
      //   attributeName: 'خودروهای سازگار',
      //   attributeSlug: 'compatible-cars',
      //   value: 'پژو ۴۰۵',
      // },
      {
        attributeId: 8,
        attributeName: 'ضخامت دیسک',
        attributeSlug: 'disc-thickness',
        value: '۲۸ میلی‌متر',
      },
      {
        attributeId: 9,
        attributeName: 'قطر دیسک',
        attributeSlug: 'disc-diameter',
        value: '۳۰۰ میلی‌متر',
      },
      {
        attributeId: 10,
        attributeName: 'نوع ترمز',
        attributeSlug: 'brake-type',
        value: 'دیسکی',
      },
      {
        attributeId: 11,
        attributeName: 'مقاومت حرارتی',
        attributeSlug: 'heat-resistance',
        value: 'تا ۷۰۰ درجه سانتی‌گراد',
      },
      {
        attributeId: 12,
        attributeName: 'وزن',
        attributeSlug: 'weight',
        value: '۷٫۸ کیلوگرم',
      },
    ],
    compatibleCars: ['پژو ۲۰۶', 'پژو ۲۰۷', 'پژو پارس', 'پژو ۴۰۵'],
    /* NEW */
    price: 2900000,
    discount: {
      price: 2450000,
      value: 15,
    },

    inventory: {
      quantity: 6,
      inStock: true,
    },

    shipping: {
      title: 'ارسال سریع',
      delivery: 'فردا',
    },

    // guarantees: [
    //   {
    //     icon: 'shield',
    //     color: 'blue',
    //     title: 'گارانتی اصالت و سلامت کالا',
    //   },
    //   {
    //     icon: 'return',
    //     color: 'purple',
    //     title: '۷ روز ضمانت بازگشت',
    //   },
    // ],
  };
  const [product, setProduct] = useState<productCardType>(sample);
  //   const [product, setProduct] = useState(data);
  const [similar, setSimilar] = useState([sample, sample, sample, sample]);
  console.log('product========', product, similarItems);

  //   useEffect(() => {
  //     const cookieName = `viewproduct-${data?.id}-${locale}`;
  //     let viewCookie = CookieFunction('get', cookieName);
  //     if (!viewCookie && data?.id) {
  //       Api.addView(data?.id)
  //         .then((res) => {
  //           CookieFunction('set', cookieName, data?.id, 0.00138888889);
  //         })
  //         .catch((err) => {});
  //     }
  //   }, []);
  return (
    <>
      <PageWrapper className={`p-0 section-light`}>
        <ViewportWrapper className={`pb-0 container`}>
          <Breadcrumb
            className={styles.breadCrumb}
            items={[
              { label: 'خانه', to: '/' },
              { label: 'فروشگاهها', to: '/shops' },
              {
                label: ` ${product?.shop?.title}`,
                to: `/shops/${product?.shop?.slug}`,
              },
              { label: product?.title || '' },
            ]}
          />
        </ViewportWrapper>
        <ViewportWrapper className={`pt-0 container`}>
          <SingleproductHero product={product} />
        </ViewportWrapper>
      </PageWrapper>

      <PageWrapper className={`p-0 section-light mt-0`}>
        <ViewportWrapper className={`pt-0 container`}>
          <ProductDetailsSection product={product} />
        </ViewportWrapper>
      </PageWrapper>

      <PageWrapper className={`w-full section-light mt-0 p-0`}>
        <div className="container py-0">
          <Features
            feat={{ title: 'کالاهای مرتبط', cards: similar }}
            position="normal"
            headClass={`${styles.similarHeadClass}`}
          >
            {({ f, index }) => <ProductCard item={f} index={index} />}
          </Features>
        </div>
      </PageWrapper>
    </>
  );
}
